var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-select', {
    attrs: {
      "items": _vm.dbList,
      "item-text": "title",
      "item-value": "id",
      "label": "Select Notion Database",
      "outlined": "",
      "required": "",
      "dense": ""
    },
    model: {
      value: _vm.selectedDbId,
      callback: function ($$v) {
        _vm.selectedDbId = $$v;
      },
      expression: "selectedDbId"
    }
  }), _vm.selectedDbProperties.length ? _c('div', [_c('h3', {
    staticClass: "mt-3 mb-5 form-integration-text"
  }, [_vm._v("Map properties")]), _vm._l(_vm.mappingRows, function (row) {
    return _c('div', {
      key: row.id,
      staticClass: "mt-0"
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "items": _vm.questions,
        "label": "Select Question",
        "item-text": "title",
        "item-value": "fieldId",
        "clearable": "",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: row.questionId,
        callback: function ($$v) {
          _vm.$set(row, "questionId", $$v);
        },
        expression: "row.questionId"
      }
    })], 1), _c('v-col', {
      staticClass: "d-flex align-center justify-center",
      staticStyle: {
        "min-height": "56px",
        "margin-top": "-1rem"
      },
      attrs: {
        "cols": "1"
      }
    }, [_c('v-icon', {
      staticClass: "my-auto",
      attrs: {
        "small": "",
        "color": "gray_500"
      }
    }, [_vm._v(" mdi-chevron-double-right ")])], 1), _c('v-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "items": _vm.getAvailablePropertiesForRow(row),
        "label": "Notion Property",
        "item-text": "name",
        "item-value": "id",
        "clearable": "",
        "outlined": "",
        "dense": "",
        "disabled": !row.questionId
      },
      model: {
        value: row.propertyId,
        callback: function ($$v) {
          _vm.$set(row, "propertyId", $$v);
        },
        expression: "row.propertyId"
      }
    })], 1), _c('v-col', {
      staticClass: "d-flex align-center pl-0",
      staticStyle: {
        "margin-top": "-1rem"
      },
      attrs: {
        "cols": "1"
      }
    }, [_vm.mappingRows.indexOf(row) > 0 ? _c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "color": "gray_500"
      },
      on: {
        "click": function ($event) {
          return _vm.removeMappingRow(row.id);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-trash-can-outline")])], 1) : _vm._e()], 1)], 1)], 1);
  }), _c('v-row', {
    staticClass: "mr-3",
    attrs: {
      "no-gutters": "",
      "justify": "end"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.addMappingRow
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Property ")], 1)], 1), _c('h3', {
    staticClass: "mt-6 form-integration-text"
  }, [_vm._v("Row Data Options")]), _c('v-radio-group', {
    staticClass: "mb-5",
    model: {
      value: _vm.displayAnswer,
      callback: function ($$v) {
        _vm.displayAnswer = $$v;
      },
      expression: "displayAnswer"
    }
  }, [_c('v-radio', {
    staticClass: "mb-3",
    attrs: {
      "label": "Display Answer Values",
      "value": "answer_values"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Display Answer Codes/Index",
      "value": "answer_codes"
    }
  })], 1), _c('div', {
    staticClass: "group-control__wrapper"
  }, [_c('f-switch', {
    staticClass: "mr-2",
    model: {
      value: _vm.sendExisting,
      callback: function ($$v) {
        _vm.sendExisting = $$v;
      },
      expression: "sendExisting"
    }
  }), _vm._v(" Export Existing Data ")], 1), _c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [_c('v-btn', {
    staticClass: "mt-6 rounded-pill font-weight-medium save-btn",
    attrs: {
      "color": "primary",
      "height": "32",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v(" Save ")])], 1)], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }